import { html, View } from 'rune-ts';
import { UtilS } from '../../../../../../modules/Util/S/Function/module/UtilS';
import { ProductCardViewData } from '../../../../features/ProductList/type';
import klass from './ProductCardPrice.module.scss';

type ProductCardPriceData = Pick<ProductCardViewData, 'price' | 'price_en' | 'price_jp'>;

export class ProductCardPrice extends View<ProductCardPriceData> {
  lang: 'kr' | 'en' | 'jp';

  constructor(
    data: ProductCardPriceData,
    private option: {
      price_klass?: string;
      currency_klass?: string;
    } = {},
  ) {
    super(data, option);
    this.lang = ET.lang;
  }

  override template() {
    return html`<span class="${klass.ProductCardPrice}">
      ${this.lang === 'kr' ? this.makeKrPriceTmpl() : this.makeEnJpPriceTmpl()}
    </span> `;
  }

  private makeKrPriceTmpl() {
    return html`<span class="price-number ${this.option.price_klass}">${this.localPriceString}</span>
      <span class="${this.option.currency_klass}">${this.currencySymbol}</span>`;
  }

  private makeEnJpPriceTmpl() {
    return html`<span class="${this.option.currency_klass}">${this.currencySymbol}</span>
      <span class="price-number ${this.option.price_klass}">${this.localPriceString}</span>`;
  }

  private get currencySymbol() {
    return UtilS.getCurrency(this.lang);
  }

  private get localPrice() {
    if (this.lang === 'kr') return this.data.price;
    if (this.lang === 'en') return this.data.price_en;
    if (this.lang === 'jp') return this.data.price_jp;
  }

  private get localPriceString() {
    return UtilS.commify(this.localPrice);
  }
}
